import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, FormSection } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import mean from 'lodash/mean';
import get from 'lodash/get';
import defaultTo from 'lodash/defaultTo';
import { LinkHelper } from '../../routes';
import EditReview from './EditReview';
import Stars from './common';
import Icon from 'react-fa';
import Load from '../../components/Load'
const styles = require('./Place.less') as any;
const ELEMENTS = require('./Elements.json') as any;
const mockPlace = require('./mock.json') as any;
import { TransitionMotion, Motion, spring } from 'react-motion'
const FAST_MOTION = {stiffness: 300, precision: .01, damping: 40}
const FAST_MOTION_STYLE = { entering: spring(0, FAST_MOTION), leaving: spring(0, FAST_MOTION), }
import { getNavPosition } from '../../Layouts/utils'
/* import { debug } from '../../../utils';
 * const log = debug('lego:Place.tsx');*/
declare var google: any;


import { fetchPlace, postReviews } from '../../models/Places';
interface PlaceProps {
		id: string;
		place: any;
		location: any;
		fetchPlace: any;
		params: any;
		router: any;
		route: any;
		selected_aspect: any;
		reviewing: any;
		handleSubmit;
		postReviews;
		pristine: boolean;
		submitting: boolean;
		reset: any;
  browser: any;
		routes: any;
		searchLink: any;
		error: any;
}

interface PlaceState { }
import map from 'lodash/map'
const serializeParams = (params: any) => map(params, (v: any, k) => `${k}=${encodeURIComponent(v)}`).join('&');

const aspect_review_template = {comment: '', rating: 0};
const my_reviews_template = {
		0: {...aspect_review_template},
		1: {...aspect_review_template},
		2: {...aspect_review_template},
		3: {...aspect_review_template},
		4: {...aspect_review_template},
		5: {...aspect_review_template},
		6: {...aspect_review_template},
		7: {...aspect_review_template},
		8: {...aspect_review_template},
		9: {...aspect_review_template},
		10: {...aspect_review_template},
		11: {...aspect_review_template},
		12: {...aspect_review_template},
		13: {...aspect_review_template},
		14: {...aspect_review_template},
		15: {...aspect_review_template},
		16: {...aspect_review_template}
};

import { C } from '../../utils'
import { handleSubmissionError, Activatable } from '../utils'
import { ReviewControlsTransition } from './ReviewControls'
import { generateQueryParams } from '../../models/Search'
import last from 'lodash/last'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'

interface AspectReview {
		comment: string;
		rating: number;
}

interface Review {
		[AspectId: number]: AspectReview
}

function validate(values: Review) {
		const errored = pickBy(map(values, review => review.comment.length > 0 && review.rating == 0)) as any
		const errors = mapValues(errored, aspect => 'Must leave a star rating.')
		if (Object.keys(errored).length > 0) 	errors._error = {...errors}
		return errors
}
const mapStateToProps = (state, ownProps) => ({
		initialValues: { ...(my_reviews_template as any), ...(get(state.places, `${ownProps.routeParams.id}.data.arb.my_reviews`, {}))},
		place: state.places[ownProps.routeParams.id],
		selected_aspect: defaultTo(parseInt(ownProps.location.query.aspect), 0),
		reviewing: ownProps.location.query.reviewing !== undefined,
  browser: state.browser,
		searchLink: '/search/?' + serializeParams(generateQueryParams(last(state.queries['__history__']))),
});
@connect(mapStateToProps, {fetchPlace, postReviews})
@reduxForm({form: 'reviewForm', enableReinitialize: true, validate, shouldValidate: () => true})//, keepDirtyOnReinitialize: true})
class Place extends React.Component< PlaceProps,PlaceState> {
		componentWillMount() {
				// TODO: get cached if exists
				// if (!this.props.place) this.props.fetchPlace({id: this.props.params.id});
			this.props.fetchPlace({id: this.props.params.id});
		}

		toggleAspect(id) {
				const params = { ...this.props.location.query,
																					aspect: this.props.selected_aspect == id ? -1 : id
				};
				const router = this.props.router;

				router.replace(router.createPath({
						pathname: this.props.location.pathname,
						query: params
				}));
		}

		render() {
				const { selected_aspect, reviewing, handleSubmit, pristine, submitting, reset, browser,
												location: url_location, routes: active_routes, searchLink, error } = this.props;
				const place = this.props.place || {id: '', inProgress: true, data: mockPlace}
				// const reviewing = route.label == 'Reviewing';
				const navPosition = getNavPosition(browser, active_routes, url_location)
				const columns = browser.lessThan.searchViewLimit ? 'oneColumn' : 'twoColumn'
				const { id, name, arb, google, location } = (place.data || mockPlace)
				const { reviews } = arb;
				const _submit = data => handleSubmissionError(this.props.postReviews)(({ ...data, id: place.id }))

			return (
				form(
					C(styles.PlaceForm),
						{ onSubmit: handleSubmit(_submit)},
					[
						div(C([styles.Place, navPosition]), [
								header(C(styles.PlaceHeader), [
								PlaceTitle({ name: name, searchLink: searchLink }),
								columns !== 'oneColumn' &&
									ReviewControlsTransition({reviewing, mountProgress, pristine, submitting, place, selected_aspect, reset, styles }),
							]),
							ol(C(styles.WindowShade),
								 ELEMENTS.map((aspect, idx) =>
															Aspect({
																//key: idx,
																idx,	aspect,
																selected_aspect,
																reviews: reviews.filter(aspectIs(aspect.id)),
																reviewing,
																place,
																navPosition,
																columns,
																error: error && error[aspect.id],
																my_review: get(place, `data.arb.my_reviews[${aspect.id}]`),
																toggleAspect: () => this.toggleAspect(idx),
															})),
								),
							columns === 'oneColumn' &&
								ReviewControlsTransition({reviewing, mountProgress, pristine, submitting, place, selected_aspect, reset, styles }),
							this.props.children,
						]),
					],
				)
			)
		}
}

const mountProgress = style => 100 - style.leaving - style.entering
const PlaceTitle = ({searchLink, name}) =>
		div(C(styles.Title), [
				h(LinkHelper, { to: searchLink }, [
						h(Icon, { name: 'angle-left' })
				]),
				h2([name])
		])

import LinkButton from '../../components/Button/LinkButton';
import Button from '../../components/Button/Button';

const MetaInfo = ({url, phone, address}) =>
		div(C(styles.InfoHeader), [
				div(C(styles.Links)),
				get(location, address) && div([
						h(Icon, { name: 'map-marker' }),
						address([get(location, address)])
				]),
		])

const NO_COMMENTS = comments => `No comments available from users similar to you.` //'but here are others..'
const NO_OTHER_COMMENTS = 'No one else has commented on this aspect.';

const aspectIs = (id) => (review) => review.aspect == id;
const hasRating = review => review && review.rating && (review.rating > 0);
const hasComment = (review) => review && review.comment && (review.comment.length > 0);
const review_template = {comment: '', stars: undefined};

const stickyStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 1000,
}

const overallStyle = {
	borderBottom: '3px solid steelblue',
	fontSize: '1.3em',
	textAlign: 'center',
}

const AspectError = () => h(Icon, C(styles.AspectErrored), { name: 'exclamation-triangle' })
const AspectHeader = ({my_review, reviews, aspect, selected_aspect, idx, toggleAspect, inProgress, error}) => (
		h(Activatable, C([styles.AspectHeader, selected_aspect == idx && styles.reviewing]),
			{
						Element: 'header',
				onActivate: toggleAspect,
				style: (idx === 0)
				? ((selected_aspect === 0)
					 ? {...overallStyle, ...stickyStyle}
					 : overallStyle)
				: {}
			},
				[
					!!(hasComment(my_review) || hasRating(my_review)) && h(Icon, C(styles.UserReviewed), { name: 'check-square-o' }), ' ', aspect.name,
						!!error && AspectError(),
						h(Load, C(styles.CompositeRating), { loading: inProgress }, [
						((!!my_review && parseInt(my_review.rating) > 0) || reviews.filter(aspectIs(aspect.id)).length > 0) &&
								h(Stars, {
									name: `${aspect.id}_mine`,
									value: my_review
										? parseInt(my_review.rating)
										: mean(reviews.filter(aspectIs(aspect.id)).map(review => parseInt(review.rating))),
									editing: false,
								}),
						]),
				],
		)
)

const Aspect = ({place, aspect, idx, my_review, reviews, selected_aspect, toggleAspect, reviewing, navPosition, columns, error}) => (
	li(
		C([styles.Aspect, reviewing && styles.Reviewing, selected_aspect == idx && styles.opened]),
		{
			key: `${idx}-${aspect.id}`,
			style: (idx === 0 && selected_aspect !== 0) ? {...stickyStyle} : {},
		},
		[
    AspectHeader({ error,
        my_review, reviews, aspect, selected_aspect, idx, toggleAspect, inProgress: place.inProgress,
      }),
				AspectContents({selected_aspect, idx, columns, reviewing, place, my_review, reviews, aspect, error}),
				columns !== 'oneColumn' && AnimatedEditReviewPane({error, reviewing, idx, selected_aspect, aspect, my_review, toggleAspect})
		],
	)
)

const AspectContents = ({selected_aspect, idx, columns, reviewing, place, my_review, reviews, aspect, error}) =>
  h(Motion,
    {style: {
      selected: selected_aspect == idx ? spring(8, FAST_MOTION) : spring(0, FAST_MOTION),
    }},
    [
      s =>
        (
          s.selected > 0 && ol(
            C(styles.Reviews),
            {
              style: {
                overflow: 'hidden',
                paddingTop: s.selected + 'px',
                paddingBottom: s.selected + 'px',
                maxHeight: s.selected == 8 ? 'none' : square(s.selected) + 'em',
                minHeight: s.selected + 'em',
              },
            },
            [
              h(Load, { loading: place.inProgress },
								[
									columns === 'oneColumn' &&
												AnimatedEditReviewPane({ error,
											reviewing, aspect, idx, selected_aspect, my_review: defaultTo(my_review, { ...review_template }),
										}),
									((!!my_review && my_review.rating > 0 && get(my_review, 'comment.length', 0) > 0) &&
									 (!reviewing || (columns !== 'oneColumn'))) &&
										Review({
											review: my_review,
											my_review: true,
											reviewing,
											editLink: `/place/${place.id}/?aspect=${selected_aspect}&reviewing`,
										}),
									(!reviewing || (columns !== 'oneColumn')) &&
										(reviews.filter(hasComment).length == 0
										 ? NoComments({ my_review, reviews })
										 : reviews.filter(hasComment).map(review => Review({ review }))),
										 !reviewing && !my_review && SubmitAReview({ place, selected_aspect }),
								]),
            ],
          )),
	  ],
   )

const AnimatedEditReviewPane = ({reviewing, idx, selected_aspect, aspect, my_review, error, toggleAspect=()=>({})}) =>
	h(TransitionMotion,
    {
      styles: !reviewing
        ? []
        : [
          {
            key: 'child',
            style: {
              entering: spring(0, idx == selected_aspect ? FAST_MOTION : FAST_MOTION),
              leaving: spring(0, FAST_MOTION),
              selecting: spring(reviewing && idx == selected_aspect ? 10 : 0, {
                stiffness: 240,
                precision: 0.01,
                damping: 32,
              }),
            },
            data: { selected: reviewing && idx == selected_aspect },
          },
        ],
      willLeave: editReviewWillLeave,
      willEnter: editReviewWillEnter,
    },
    [
      now =>
        div([
          now.map(({ style, key, data }) => {
            const { selected } = data
            const { entering, leaving, selecting } = style
            const mounted = 100 - leaving - entering
            const marginLeft = (mounted > 50
																? -0.03 * square(selecting) + 0.3 * selecting - 0.7
																: 0) + 'em'
            const left = curve(25, mounted / 10) + '%'
            return h(FormSection, {name: aspect.id}, [h(EditReview, {
              zIndex: mounted >= 90 && selecting > 5 ? 100 : -1,
              key: key,
														error,
              review: defaultTo(my_review, { ...review_template }),
              style: { left, marginLeft },
              aspect, idx, selected: reviewing && selected, toggleAspect,
            })])
          }),
        ]),
    ],
   )

const NoComments = ({my_review, reviews}) =>
		div(C(styles.NoComments), [
				p([my_review ? NO_OTHER_COMMENTS : NO_COMMENTS(reviews.length)])
		])

const SubmitAReview = ({place, selected_aspect}) =>
	div(C(styles.WriteReview), [
				hr(),
				h(LinkButton, { to: `/place/${place.id}/?aspect=${selected_aspect}&reviewing` }, [
						'Write a review',
				]),
		])

const square = x => x * x
const curve = (b, x) => (1 - b/10) * square(x) + b * x
const passAndLogFn = (label) => (fn) => (...args) => {
		const out = fn(...args)
		console.log(label, ...args, fn)
		return out
}
const logAndReturn = (out) => (label?) => {console.log(label, out); return out}
const editReviewWillEnter = ({data}) => ({
		entering: 100, leaving: 0, selecting: 0,
})
const editReviewWillLeave = ({data}) => ({
		entering: spring(0), leaving: spring(100),
		selecting: data.selected ? spring(10) : spring(0)
})

import { form, p, header, h2, address, h, ol, li, div, span, label, hr } from 'react-hyperscript-helpers'
const Review = ({review, my_review=false, reviewing=false, editLink=''}) =>
		li(C(styles.Review), { key: `${review.id}-review` }, [
				div(C(styles.ReviewHeader), [
						span(C(styles.EditedTime), [moment(review.edited).fromNow()]),
						span(C(styles.ReviewRating), [
								h(Stars, {
										name: `${review.aspect}_rating`,
										value: review.rating,
										editing: false,
								}),
						]),
				]),
			label(C(styles.username), [(!!my_review && 'You') || review.username, review.comment.length > 0 ? ' said: ' : '']),
			div(C(styles.comment), [
					review.comment ||	span({ style: { fontStyle: 'italic' } }, ['left an empty comment']),
					!reviewing && my_review &&
							h(LinkHelper, C(styles.EditReviewLink),
									{ to: editLink }, [
											h(Icon, { name: 'edit' }), 'Edit'
									]),
				]),
				!!my_review && hr(),
		])

/* ({reviews
 *		 .filter(aspectIs(aspect.id))
 *		 .filter(hasComment)
 *		 .length} comments, {reviews.filter(aspectIs(aspect.id)).length} ratings)*/

export default withRouter(Place);



// WEBPACK FOOTER //
// ./src/app/containers/Place/Place.ts